import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface UserPointFilters {
  loginName: string
  nickName: string
}

export interface UserPointRecord {
  id: number
  loginName: string
  nickName: string
  point: number
}

export interface PointRecordFilters {
  userId: number
  flow: 0 | 1
}

export interface PointRecord {
  id?: number
  reason: string
  num: number
  remark: string
  createdTime: string
}

export interface PointReason {
  reason: string
  point: number
}

interface ChangePointPayload {
  reason: string
  changePoint: number
  type: 0 | 1
}

interface BatchUpdatePayload {
  excelDatas: unknown[]
  points: number
}

export interface BatchUpdateResult {
  flag?: boolean
  duplicates: unknown[]
  unknowns: unknown[]
}

export async function fetchUserPointPage(
  query: PageQuery<UserPointFilters>,
  signal: AbortSignal
): Promise<PageResult<UserPointRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/userExpand/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<UserPointRecord>(payload)
}

export async function fetchPointRecordPage(
  query: PageQuery<PointRecordFilters>,
  signal: AbortSignal
): Promise<PageResult<PointRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/pointRecord/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<PointRecord>(payload)
}

export async function fetchPointReasons(flow: 0 | 1) {
  const reasons = await requestV2.get<PointReason[]>({
    url: '/main/pointReason/list',
    params: { flow }
  })
  if (!Array.isArray(reasons)) throw new Error('积分原因响应必须是数组')
  return reasons
}

export function changeUserPoint(userId: number, payload: ChangePointPayload) {
  return requestV2.put<void>({
    url: `/main/userExpand/${userId}/changePoint`,
    data: payload
  })
}

export function batchUpdateUserPoint(payload: BatchUpdatePayload) {
  return requestV2.post<BatchUpdateResult>({
    url: '/main/userExpand/batch/update',
    data: payload
  })
}
